import { createCsrfMiddleware, createStart } from "@tanstack/react-start";

const allowedOrigins = [
  "https://atalaythecoach.com",
  "https://staging.atalaythecoach.com",
];

const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === "serverFn",
  allowRequestsWithoutOriginCheck: true,
  origin: (value) => allowedOrigins.includes(value),
  referer: false,
});

export const startInstance = createStart(() => {
  return {
    serializationAdapters: [],
    functionMiddleware: [
      // sentryGlobalFunctionMiddleware as unknown as AnyFunctionMiddleware,
    ],
    requestMiddleware: [csrfMiddleware],
  };
});
